import Hero from "../components/home/Hero";
import Ticker from "../components/home/Ticker";
import Manifesto from "../components/home/Manifesto";
import Categories from "../components/home/Categories";
import Signature from "../components/home/Signature";
import Editorial from "../components/home/Editorial";
import Gallery from "../components/home/Gallery";
import Visit from "../components/home/Visit";
import Discovery from "../components/home/Discovery";
import Team from "../components/home/Team";
import Promo from "../components/home/Promo";
import Voices from "../components/home/Voices";
import Journal from "../components/home/Journal";
import Closing from "../components/home/Closing";
import { useDocumentTitle } from "../lib/title";
import "../components/home/home.css";

export default function Home() {
  useDocumentTitle();

  return (
    <>
      <Hero />
      <Ticker />
      <Manifesto />
      <Categories />
      <Signature />
      <Editorial />
      <Gallery />
      <Visit />
      <Discovery />
      <Team />
      <Promo />
      <Voices />
      <Journal />
      <Closing />
    </>
  );
}
